/* jshint esversion: 6 */
import { LocalNotifications } from '@capacitor/local-notifications';
import store from '../store';
import push from './push.js';
import * as types from '../store/mutation-types';
import bus from '../services/bus-event';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import router from '../router';
import { quoteFromDeepLinkQuery, savePendingTripQuote } from '../services/tripQuoteBridge';

let pendingDeepLinkUrl = null;

const handleDeepLink = (url) => {
    try {
        if (!url || typeof url !== 'string') return;
        // Example: myride://reserva-ok?pago_reserva_id=123&result=success
        const u = new URL(url);
        const routeKey = (u.hostname || '').toLowerCase();
        const query = {};
        u.searchParams.forEach((v, k) => { query[k] = v; });

        if (routeKey === 'reserva-ok') {
            router.push({ name: 'reserva-ok', query });
        } else if (routeKey === 'reserva-error') {
            router.push({ name: 'reserva-error', query });
        } else if (routeKey === 'reservas') {
            router.push({ name: 'reservas', query });
        } else if (routeKey === 'pedir-viaje') {
            const quote = quoteFromDeepLinkQuery(query);
            if (quote) {
                savePendingTripQuote(quote);
            }
            router.push({ name: 'home' });
        } else {
            // Unknown deep link; go home.
            router.push({ name: 'home' });
        }
    } catch (e) {
        console.warn('Deep link parse failed', e);
    }
};

export async function clearAllNotifications () {
    if (process.env.CORDOVA) {
        const pending = await LocalNotifications.getPending();
        if (pending.notifications.length > 0) {
            return LocalNotifications.cancel({ notifications: pending.notifications });
        }
    }
}

let onDeviceReady = async () => {
    console.log('Device ready');
    const device = await Device.getInfo();

    store.commit('cordova/' + types.CORDOVA_DEVICEREADY);
    store.commit('cordova/' + types.CORDOVA_SET_DEVICE, device);

    window.device = device;

    const app = await App.getInfo();
    console.log('App ready', app);
    if (app) {
        store.commit('cordova/' + types.CORDOVA_SET_VERSION, app.build);
    }

    // if (window.PushNotification || window.Pushy) {
    push.init();
    // }

    // Handle deep links from payment returns (Mercado Pago -> backend -> app).
    try {
        App.addListener('appUrlOpen', (data) => {
            if (data && data.url) {
                pendingDeepLinkUrl = data.url;
                // If app is ready, handle immediately; otherwise it'll be handled on system-ready.
                if (router && router.currentRoute) {
                    handleDeepLink(pendingDeepLinkUrl);
                    pendingDeepLinkUrl = null;
                }
            }
        });
    } catch (e) {
        console.warn('Failed to register appUrlOpen listener', e);
    }

    bus.on('system-ready', () => {
        if (pendingDeepLinkUrl) {
            handleDeepLink(pendingDeepLinkUrl);
            pendingDeepLinkUrl = null;
        }
    });

    clearAllNotifications();

    document.addEventListener('online', onOnline, false);
    document.addEventListener('offline', onOffline, false);
    document.addEventListener('backbutton', onBackbutton, false);
    document.addEventListener('pause', onPause, false);
    document.addEventListener('resume', onResume, false);

    store.dispatch('init', true);
};

let onOnline = () => {
    store.dispatch('cordova/deviceOnline');
};

let onOffline = () => {
    store.dispatch('cordova/deviceOffline');
};

let onBackbutton = () => {
    store.dispatch('cordova/onBackButton');
};

let onPause = () => {
    store.dispatch('cordova/onPausa');
};

let onResume = () => {
    store.dispatch('cordova/onResume');
};

document.addEventListener('deviceready', onDeviceReady, false);



// WEBPACK FOOTER //
// ./src/cordova/index.js